export enum AttachmentDrawerType {
  TRANSACTION = "TRANSACTION",
  ATTACHMENT = "ATTACHMENT",
}
